import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

export const useNumberFromIntl = (): ((value?: string | number) => number) => {
  const locale = useSelector(select.locale.get);
  const currency = useSelector(select.currency.get);

  const numberParts = useMemo(
    () =>
      new Intl.NumberFormat(locale, {
        style: 'currency',
        currency
      }).formatToParts(
        10000000.33 // Using a big enough number to guarantee we get all the separators
      ),
    [currency, locale]
  );

  const decimalSeparator = useMemo(
    () => numberParts.find(({ type }) => type === 'decimal')?.value,
    [numberParts]
  );

  const getNumberFromIntl = useCallback(
    (value: string | number = 0) =>
      decimalSeparator ? Number(value.toString().replace(decimalSeparator, '.')) : 0,
    [decimalSeparator]
  );

  return getNumberFromIntl;
};
